$(document).ready(function(){
	var wishlist = $('.wishlistForm');
	var timeout;

	wishlist.on('submit',function(e){
		e.preventDefault();
		var $this = $(this);
		var data = $(this).serialize();
		$.ajax({
			type: 'POST',
			url: '/',
			data: data,
			cache: false,
			dataType: 'json',
			error: function(jqXHR, textStatus, errorThrown) {
				console.log(jqXHR);
			},
			success: function(response) {
				if (response.items[0].action == 'removed') {
					$this.find('.btn--fav').removeClass('active').addClass('inactive');
					if ($('body').hasClass('type--myAccount')) {
						timeout = setTimeout(function(){
							$this.parents('.card').remove();
							if ($('#collections__list').children().length == 0) {
								location.reload();
							}
						},1600);
					}
				} else {
					$this.find('.btn--fav').removeClass('inactive').addClass('active');
					if ($('body').hasClass('type--myAccount')) {
						clearTimeout(timeout);
					}
				}
			}
		});
	});

});